import React from 'react';
import { Reveal } from './Reveal';
const modulos = [{
  emoji: '📦',
  n: 'Módulo 1',
  name: 'Fundamentos y materiales',
  temas: 'Tipos de globos, herramientas, proveedores, cuidados básicos'
}, {
  emoji: '🎨',
  n: 'Módulo 2',
  name: 'Teoría del color y diseño',
  temas: 'Combinaciones, paletas, estilos temáticos, tendencias'
}, {
  emoji: '🔗',
  n: 'Módulo 3',
  name: 'Técnicas de armado base',
  temas: 'Nudos, uniones, inflado manual y con bomba'
}, {
  emoji: '🌈',
  n: 'Módulo 4',
  name: 'Arcos y guirnaldas',
  temas: 'Arco orgánico, arco estructurado, guirnalda colgante'
}, {
  emoji: '🏛️',
  n: 'Módulo 5',
  name: 'Columnas y torres',
  temas: 'Estructuras verticales, bases, proporciones'
}, {
  emoji: '🖼️',
  n: 'Módulo 6',
  name: 'Decoración de mesas',
  temas: 'Centros, backdrop de globos, mesas de dulces'
}, {
  emoji: '📸',
  n: 'Módulo 7',
  name: 'Fotografía y redes sociales',
  temas: 'Cómo mostrar tu trabajo y atraer clientes'
}, {
  emoji: '💼',
  n: 'Módulo 8',
  name: 'Emprendimiento y precios',
  temas: 'Presupuestos, costos, clientes, primeros trabajos'
}];
export function Modulos() {
  return <section className="w-full bg-[#2f2a33] py-24" data-id="element-99" data-mp="15cgcgav1xr8y">
      <div className="mx-auto max-w-6xl px-6" data-id="element-100" data-mp="10b0s6l0p7orm">
        <Reveal data-id="element-101" data-mp="10ddh5i4vize6">
          <p className="text-center text-sm font-semibold uppercase tracking-widest text-[#f4d160]" data-id="element-102" data-mp="clpytologwni">
            Contenido del curso
          </p>
          <h2 className="font-display mt-3 text-center text-3xl font-semibold text-white sm:text-4xl" data-id="element-103" data-mp="7nwtexs786oa">
            ¿Qué vas a aprender?
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-104" data-mp="hk9lxsc0cehg">
          {modulos.map((m, i) => <Reveal key={i} delay={i % 2 * 0.06} data-id="element-105" data-mp="1xysqxjfemy1b" data-mpi={i}>
              <div className="group flex h-full items-start gap-4 rounded-2xl bg-white/5 p-6 ring-1 ring-white/10 transition hover:bg-white/10" data-id="element-106" data-mp="1xx7v7qhct91v">
                <span className="text-3xl" data-id="element-107" data-mp="203egittn5wv9">{m.emoji}</span>
                <div data-id="element-108" data-mp="202wbb7p048b7">
                  <span className="text-xs font-semibold uppercase tracking-wider text-[#ec4899]" data-id="element-109" data-mp="25290w079bthh">
                    {m.n}
                  </span>
                  <h3 className="mt-1 text-lg font-semibold text-white" data-id="element-110" data-mp="2a2nahmoibbhm">
                    {m.name}
                  </h3>
                  <p className="mt-1.5 text-sm text-white/60" data-id="element-111" data-mp="2ezndtptz2051">{m.temas}</p>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}